import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

function pickMessage(error) {
  const data = error.response?.data
  if (data?.message) return data.message
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors.map((e) => e.message).join(' ')
  }
  return 'Request failed'
}

export const subscriptionTypeAdminService = {
  async list() {
    try {
      const response = await api.get('/subscription-types')
      const body = response.data
      return body?.data?.subscription_types ?? []
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw new Error(msg)
    }
  },

  async create(payload) {
    try {
      const response = await api.post('/subscription-types', payload)
      const body = response.data
      toast.success(body?.message || 'Subscription type created')
      return body?.data?.subscription_type ?? body?.data
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  },

  async update(subscriptionCode, payload) {
    try {
      const response = await api.put(`/subscription-types/${encodeURIComponent(subscriptionCode)}`, payload)
      const body = response.data
      toast.success(body?.message || 'Subscription type updated')
      return body?.data?.subscription_type ?? body?.data
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  },

  async destroy(subscriptionCode) {
    try {
      const response = await api.delete(`/subscription-types/${encodeURIComponent(subscriptionCode)}`)
      const body = response.data
      toast.success(body?.message || 'Subscription type deleted')
      return true
    } catch (error) {
      const msg = pickMessage(error)
      toast.error(msg)
      throw Object.assign(new Error(msg), { response: error.response })
    }
  }
}
